import styled from '@emotion/styled';
import Image from '@base/FutureImage';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import AquillaButton from 'aquilla/core/molecules/Button';
import { useIsMobile } from '@stores/AppCommonData';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    gap: ${Spacings.SPACING_4B};
  }
`;

const LeftWrapper = styled.div<{ $gap: string }>`
  width: 587px;
  display: flex;
  flex-direction: row;
  gap: ${({ $gap }) => $gap || '24px'};
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${Spacings.SPACING_1B};
`;

const Title = styled.div<{ $smallFont: boolean }>`
  font-size: ${({ $smallFont }) =>
    $smallFont ? `${Fonts.SMALL}` : `${Fonts.H4}`};
  font-weight: ${({ $smallFont }) =>
    $smallFont ? `${Fonts.SEMIBOLD}` : `${Fonts.HEAVY}`};
  color: var(--color-base-fill);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
    font-weight: ${Fonts.SEMIBOLD};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
`;

const SubTitle = styled.div`
  font-size: ${Fonts.SMALL};
  font-style: normal;
  font-weight: 400;
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
    font-weight: 400;
  }
`;

const StyButton = styled(AquillaButton)<{ $smallFont: boolean }>`
  min-width: ${({ $smallFont }) => ($smallFont ? '128px' : '130px')};
  border: ${({ $smallFont }) => ($smallFont ? '1px solid #F0F4F7' : '')};
  ${mediaQuery.uptoMobile} {
    min-width: 100%;
  }
`;

interface NotesCardProps {
  title: string;
  subTitle: string;
  icon?: any;
  iconWidth: number;
  iconHeight: number;
  buttonText: string;
  gap: string;
  smallFont?: boolean;
  onClick: Function;
  buttonType:
    | 'primary'
    | 'secondary'
    | 'brand'
    | 'danger'
    | 'danger-outline'
    | 'ghost';
}

const NotesTrackCard = ({
  title,
  subTitle,
  icon,
  iconWidth,
  iconHeight,
  buttonText,
  gap,
  smallFont = false,
  buttonType,
  onClick
}: NotesCardProps) => {
  const isMobile = useIsMobile();

  return (
    <Container>
      <LeftWrapper $gap={gap}>
        <Image
          src="store/notes/notesContainer.svg"
          height={iconHeight}
          width={iconWidth}
          alt="Delivery Address"
        />
        <InfoWrapper>
          <Title $smallFont={smallFont}>{title}</Title>
          <SubTitle>{subTitle}</SubTitle>
        </InfoWrapper>
      </LeftWrapper>
      <StyButton
        $smallFont={smallFont}
        label={buttonText}
        onClick={() => onClick()}
        fullWidth={!!isMobile}
        size="medium"
        variant={buttonType}
      />
    </Container>
  );
};

export default NotesTrackCard;
